<app-side-nav></app-side-nav>
<div class="main-content">
  <!-- <app-header></app-header> -->
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
